import React, { useContext } from 'react'
import formStyles from 'styles/form.module.scss'
import { Field } from 'react-final-form'
import DeviceId from 'utils/detectDevice'
import { required, inputHasErr, composeValidators } from 'utils/validations'
import { FormDataContext } from 'providers/FormData'
import Dropdown from 'react-dropdown'
import { getCountryDropdownOptions } from 'api/transformers'
import { GenderContext } from 'components/fields/registration/GenderContext'
import useTracking from 'hooks/useTracking'
import FieldTracking from 'components/FieldTracking'

const genderPronounMapForLocation = {
  Male: 'Where does he live?',
  Female: 'Where does she live?',
}

const Location = ({ domainCountry }) => {
  const { formData, loading } = useContext(FormDataContext)
  const countryOptions = getCountryDropdownOptions(formData.countries)
  const handleChange = useTracking('countryofresidence')

  return (
    !loading && (
      <div className="form-row">
        <GenderContext>
          {({ gender, postedby }) => {
            let locationLabel =
              postedby === 'Self'
                ? 'Where do you live?'
                : genderPronounMapForLocation[gender]
            return (
              <label className={`${formStyles.label} col-md-12`}>
                {locationLabel}
              </label>
            )
          }}
        </GenderContext>

        <Field
          name="countryofresidence"
          validate={composeValidators(required('countryofresidence'))}
        >
          {({ input, meta }) => (
            <div className="col-md-12">
              {DeviceId.isDesktop() && (
                <Dropdown
                  controlClassName="countryofresidence_selector"
                  menuClassName="countryofresidence_options"
                  options={countryOptions}
                  value={domainCountry}
                  onBlur={handleChange()}
                  placeholder={domainCountry}
                  className={`${inputHasErr(meta) && formStyles.inputError}`}
                  {...input}
                />
              )}

              {DeviceId.isMobile() && (
                <select
                  data-testid="countryofresidence_selector"
                  className={`form-control ${inputHasErr(meta) &&
                    formStyles.inputError} ${formStyles.selectMobile}`}
                  {...input}
                >
                  <option value={domainCountry} hidden>
                    {domainCountry}
                  </option>
                  {countryOptions.map((group, index) => {
                    return (
                      <optgroup key={index} label={group.name}>
                        {group.items &&
                          group.items.map((item, index) => (
                            <option value={item.value} key={index}>
                              {item.label}
                            </option>
                          ))}
                      </optgroup>
                    )
                  })}
                </select>
              )}
              {meta.touched && meta.error && (
                <span
                  data-testid="countryofresidence_error"
                  className={formStyles.error}
                >
                  {meta.error}
                </span>
              )}
            </div>
          )}
        </Field>
        <FieldTracking name="countryofresidence" />
      </div>
    )
  )
}
export default Location
